import { Box, Button, Container, Paper, styled, Typography } from '@mui/material';
import { FC, useCallback, useContext } from 'react';
import { ClientConfigurationContext, LogoutForm } from '@ngt/openiddict';
import { useLocation } from 'react-router-dom';
import { parse } from 'qs';
import useNavigate from '@/hooks/router/useNavigate';
import useQueryString from '@/hooks/router/useQueryString';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))


const Paragraph = styled(Typography)(({ theme }) => ({
    margin: theme.spacing(2, 0),

    '&:first-of-type': {
        marginTop: 0
    }
}))

const qsValues = [
    {
        key: 'redirectUrl' as 'redirectUrl',
        names: [
            'redirecturl',
            'returnurl',
            'returnuri'
        ]
    }
]

const Logout: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { redirectUrl } = useQueryString(qsValues);

    const onAction = useCallback(async (url: string) => {
        navigate(url);
    }, [navigate]);

    return (
        <Container maxWidth="md">
            <Typography variant="h1" gutterBottom>
                Logout
            </Typography>
            <StyledPaper>
                <Paragraph variant="body1">
                    Logging out will log out of all connected applications.
                </Paragraph>
                <Paragraph variant="body1">
                    Do you wish to continue?
                </Paragraph>
                <LogoutForm
                    redirectUrl={redirectUrl}
                    onCancel={onAction}
                    onLogout={onAction}
                />
            </StyledPaper>
        </Container>
    );
}

export default Logout;